import { render } from "./Datepicker.vue?vue&type=template&id=4889e25c"
import script from "./Datepicker.vue?vue&type=script&lang=js"
export * from "./Datepicker.vue?vue&type=script&lang=js"
script.render = render

export default script